export const TrashContainers: any[] = [
  {
    name: 'Soterrado Quilla',
    location: {
      address: 'Av. Melchor Perez y Quilla',
      coords: {
        lat: '-17.369246989315144',
        lng: '-66.17600698270024'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. República',
    location: {
      address: 'Av. República y Av. Barrientos',
      coords: {
        lat: '-17.416843',
        lng: '-66.151695'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Capitán Victor Ustáriz',
    location: {
      address: 'Av. Capitán Victor Ustáriz y Av. Litoral',
      coords: {
        lat: '-17.396269',
        lng: '-66.175344'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Lucas Mendoza',
    location: {
      address: 'Jose Aguirre Acha y Lucas Mendoza',
      coords: {
        lat: '-17.374868',
        lng: '-66.167082'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Heroínas',
    location: {
      address: 'Av. Heroínas (Parque la Torre)',
      coords: {
        lat: '-17.390004',
        lng: '-66.145537'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Pulacayo',
    location: {
      address: 'B.M. Pulacayo entre Enrique Arze y Simeon Roncal',
      coords: {
        lat: '-17.370625',
        lng: '-66.165419'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Julio Rodriguez',
    location: {
      address: 'Av. Julio Rodríguez Morales entre Potosí y C.P. Dalence',
      coords: {
        lat: '-17.370081',
        lng: '-66.153707'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Guillermo Urquidi',
    location: {
      address: 'M. Ricardo Terrazas y Av. Guillermo Urquidi',
      coords: {
        lat: '-17.395473',
        lng: '-66.143401'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Hans Greter',
    location: {
      address: 'Hans Greter  y Parquel el Maestro',
      coords: {
        lat: '-17.397218',
        lng: '-66.137926'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Jose A. Arze',
    location: {
      address: 'Jose A. Arze y Parque el Maestro',
      coords: {
        lat: '-17.393917',
        lng: '-66.139637'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Franz Tamayo',
    location: {
      address: 'Av. Franz Tamayo y Moctezuma',
      coords: {
        lat: '-17.392212',
        lng: '-66.136481'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Sucre',
    location: {
      address: 'Sucre y C. Aurelio Melean',
      coords: {
        lat: '-17.392505',
        lng: '-66.147576'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Papa Paulo',
    location: {
      address: 'Av. Papa Paulo y C. Venezuela',
      coords: {
        lat: '-17.383809',
        lng: '-66.147601'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Eufronio Viscarra',
    location: {
      address: 'C. Eufronio Viscarra casi Erasmo Arce ',
      coords: {
        lat: '-17.382580',
        lng: '-66.148773'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Del Ejercito',
    location: {
      address: 'Av. Del Ejercito y C. 16 de Julio',
      coords: {
        lat: '-17.381592',
        lng: '-66.155403'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado M.M. Marques',
    location: {
      address: 'C. M.M.Marques y Av. Villalobos',
      coords: {
        lat: '-17.372449',
        lng: '-66.141206'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Final America Este',
    location: {
      address: 'Av. Final America Este y Av. Uyuni',
      coords: {
        lat: '-17.374065',
        lng: '-66.137103'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Segunda',
    location: {
      address: 'Av. Segunda casi Av. Simón Lopez',
      coords: {
        lat: '-17.357040',
        lng: '-66.185029'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Las Begonias',
    location: {
      address: 'Av. Las Begonias entre Isaac Maldonado y Franklin Antezana',
      coords: {
        lat: '-17.365308',
        lng: '-66.138963'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Av. Copacabana',
    location: {
      address: 'Pje. Portales 568, Cochabamba',
      coords: {
        lat: '-17.425974',
        lng: '-66.162205'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Torrentera Cantarrana',
    location: {
      address: 'C. Elena Rendony Torrentera Cantarrana',
      coords: {
        lat: '-17.367466',
        lng: '-66.157742'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  },
  {
    name: 'Soterrado Araucarias',
    location: {
      address: 'Araucaria y Amboro',
      coords: {
        lat: '-17.420259',
        lng: '-66.133419'
      }
    },
    photo: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
  }
];